import { AnalyticsProvider } from '@kueski-dev/web-observability';
import { identify, Identify } from '@amplitude/analytics-browser';

const amplitude: AnalyticsProvider = {
  updateAttribution: (attribution) => {
    const identifier = new Identify();
    Object.entries(attribution).forEach(([key, value]) => {
      if (value) {
        identifier.set(key, value);
      } else {
        identifier.unset(key);
      }
    });
    return identify(identifier).promise;
  },
};

export default amplitude;
